import React from 'react';
import BRAND from '../brand';
import { openPlatformLink } from '../platform';

function BotMenuPage({ setActivePage }) {
  const menuItems = [
    {
      id: 'menu',
      icon: '🌼',
      title: 'Каталог',
      description: 'Выберите цветы',
    },
    {
      id: 'orders',
      icon: '📦',
      title: 'Мои заказы',
      description: 'История заказов',
    },
    // Пункт «Поддержка» есть только если у инстанса настроен адрес поддержки
    ...(BRAND.supportUrl ? [{
      id: 'support',
      icon: '💬',
      title: 'Поддержка',
      description: 'Связаться с нами',
    }] : []),
  ];

  const handleItemClick = (itemId) => {
    if (itemId === 'support') {
      // Открываем чат с поддержкой
      openPlatformLink(BRAND.supportUrl);
    } else {
      setActivePage(itemId);
    }
  };

  return (
    <div style={{
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      maxWidth: '500px',
      margin: '0 auto',
    }}>
      <h1 style={{
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '8px',
        textAlign: 'center',
      }}>
        Меню {BRAND.name} 🌿
      </h1>
      <p style={{
        textAlign: 'center',
        color: '#666',
        marginBottom: '16px',
      }}>
        Выберите действие:
      </p>

      {menuItems.map((item) => (
        <button
          key={item.id}
          onClick={() => handleItemClick(item.id)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            padding: '20px',
            backgroundColor: '#fff',
            border: '1px solid #DDD',
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'all 0.2s',
            fontSize: '16px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#f5f5f5';
            e.currentTarget.style.transform = 'scale(1.02)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#fff';
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          <span style={{ fontSize: '32px' }}>{item.icon}</span>
          <div style={{ flex: 1, textAlign: 'left' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
              {item.title}
            </div>
            <div style={{ fontSize: '14px', color: '#666' }}>
              {item.description}
            </div>
          </div>
          <span style={{ fontSize: '20px', color: '#999' }}>›</span>
        </button>
      ))}
    </div>
  );
}

export default BotMenuPage;
